(() => {
  const root = document.querySelector('[data-ap-site-callback]');
  if (!root || root.dataset.ready) return;
  const launcher = root.querySelector('[data-apsc-launcher]');
  const dialog = root.querySelector('dialog');
  if (!launcher || !dialog || typeof dialog.showModal !== 'function') return;
  root.dataset.ready = 'true';
  launcher.setAttribute('aria-haspopup', 'dialog');
  launcher.setAttribute('aria-controls', dialog.id);
  launcher.setAttribute('aria-expanded', 'false');
  const form = root.querySelector('form');
  const marker = 'ap-site-callback-submitted-at';
  let previousFocus;
  const open = () => {
    if (dialog.open) return;
    previousFocus = document.activeElement;
    dialog.showModal();
    launcher.setAttribute('aria-expanded', 'true');
    const target = dialog.querySelector('[data-apsc-errors], [data-apsc-success], #apsc-name');
    target?.focus({ preventScroll: true });
  };
  launcher.addEventListener('click', event => { event.preventDefault(); open(); });
  root.querySelector('[data-apsc-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const r = dialog.getBoundingClientRect();
    if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    launcher.setAttribute('aria-expanded', 'false');
    if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
  });
  form?.addEventListener('submit', () => {
    try { sessionStorage.setItem(marker, String(Date.now())); } catch (_) {}
  });
  let submittedRecently = false;
  try { const at = Number(sessionStorage.getItem(marker)); submittedRecently = at > 0 && Date.now() - at < 1800000; } catch (_) {}
  const hasResult = !!dialog.querySelector('[data-apsc-success], [data-apsc-errors]');
  if (hasResult && (submittedRecently || location.hash === '#ap-site-callback-form')) {
    open();
    try { sessionStorage.removeItem(marker); } catch (_) {}
  }
  let frame, chatButton, observedRoots = [];
  const visibleRect = element => {
    if (!element || element.closest('[hidden], [inert]')) return null;
    const style = getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden') return null;
    const rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 ? rect : null;
  };
  const chatParts = () => {
    const host = document.querySelector('shopify-chat');
    const roots = [];
    const visit = (node, depth = 0) => {
      if (!node || depth > 4) return;
      roots.push(node);
      if (node.shadowRoot) visit(node.shadowRoot, depth + 1);
      for (const child of node.querySelectorAll('*')) {
        if (child.shadowRoot) visit(child.shadowRoot, depth + 1);
      }
    };
    visit(host);
    return { roots, button: roots.map(node => node.querySelector('[part~="activator"]')).find(Boolean) };
  };
  const align = () => {
    frame = null;
    const { roots, button } = chatParts();
    if (roots.length !== observedRoots.length || roots.some((node, index) => node !== observedRoots[index])) {
      chatObserver.disconnect();
      for (const node of roots) chatObserver.observe(node, {
        subtree: true, childList: true, attributes: true,
        attributeFilter: ['aria-expanded', 'class', 'style', 'hidden', 'inert']
      });
      observedRoots = roots;
    }
    if (button !== chatButton) {
      sizeObserver?.disconnect();
      chatButton = button;
      if (button) sizeObserver?.observe(button);
    }
    launcher.removeAttribute('data-chat-open');
    const rect = visibleRect(button);
    if (rect && button.getAttribute('aria-expanded') !== 'true') {
      const width = document.documentElement.clientWidth;
      const maxRight = Math.max(12, width - launcher.getBoundingClientRect().width - 12);
      const maxBottom = Math.max(12, window.innerHeight - launcher.getBoundingClientRect().height - 12);
      launcher.style.setProperty('--apsc-right', `${Math.min(maxRight, Math.max(12, width - rect.right))}px`);
      launcher.style.setProperty('--apsc-bottom', `${Math.min(maxBottom, Math.max(12, window.innerHeight - rect.top + 12))}px`);
    } else if (!button) {
      launcher.style.removeProperty('--apsc-right');
      launcher.style.removeProperty('--apsc-bottom');
    }
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(align); };
  const chatObserver = new MutationObserver(schedule);
  const sizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
  const mountObserver = new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes, ...record.removedNodes].some(node =>
      node.nodeType === 1 && (node.matches('shopify-chat') || node.querySelector('shopify-chat'))
    ))) schedule();
  });
  mountObserver.observe(document.body, { childList: true, subtree: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.visualViewport?.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('pageshow', schedule);
  document.addEventListener('shopify:section:load', schedule);
  [0, 500, 1500, 3500].forEach(delay => setTimeout(schedule, delay));
  setInterval(() => {
    if (!document.hidden) schedule();
  }, 5000);
})();
